import { Theme, createStyles, makeStyles, fade } from '@material-ui/core/styles';
import GlobalStyles from '../../../../styles/GlobalStyles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      // padding: theme.spacing(1, 1),
      borderRadius: 0,
      paddingTop: 12,
      paddingLeft: 24,
      paddingRight: 24,
      paddingBottom: 16
    },
    fileInputWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      paddingTop: 12,
      paddingBottom: 12,
      alignSelf: 'flex-end'
    },
    button: {
      margin: theme.spacing(1, 0, 2, 2),
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 400,
    },
    errorText: {
      color: '#f44336'
    },
    textLabel: {
      paddingLeft: 16,
      marginTop: 6,
      marginBottom: 6
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    instructions: {
      // paddingBottom: 12,
      alignSelf: 'center'
    },
    sectionTitle: {
      paddingTop: 16,
      paddingBottom: 16
    },
    messageText:{
      color:'#f44336',
      textAlign: 'end'
    },
    displayValue:{
      alignSelf: 'center',
      color: GlobalStyles.primaryColor
    },
    formRow: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: -10,
      justifyContent: 'space-between',
      height: '64px'
    },
    svgIcon: {
      '&:hover': {
        cursor: "pointer",
        backgroundColor: fade(theme.palette.common.white, 0.25),
      }
    },
    supplierSwitch: {
      '&$checked': {
        '& + $track': {
          backgroundColor: '#52d869',
        }
      }
    }
  }),
);